(function () {
    let ctr = document.getElementById("ctr-form-boletin");

    let inicalizador = () => {
        let formulario = ctr.querySelector("form");
        if (formulario) {
            formulario.addEventListener("submit", (e) => {
                e.preventDefault();

                const formData = new FormData(e.target)
                const url = e.target.getAttribute("action")+"?v="+(new Date().getTime());


                NProgress.start();
                axios.post(url, formData)
                    .then(function (response) {
                        ctr.innerHTML = response.data;
                        inicalizador();
                    })
                    .catch(function (error) {
                        console.log("-> error", error);
                    })
                    .finally(function () {
                        NProgress.done();
                    });
            });
        }
    }

    inicalizador();
})();
